// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const IntegrationChecker: MarkdocTagRegistration = {
  tag: 'integration-checker',
  component: 'IntegrationChecker',
  attributes: {
    type: {type: String, required: false},
  },
};
